import { render, staticRenderFns } from "./maxMenuTip.vue?vue&type=template&id=8874bde6&scoped=true"
import script from "./maxMenuTip.vue?vue&type=script&lang=js"
export * from "./maxMenuTip.vue?vue&type=script&lang=js"
import style0 from "./maxMenuTip.vue?vue&type=style&index=0&id=8874bde6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8874bde6",
  null
  
)

export default component.exports